import { c as _c } from "react/compiler-runtime";
import { IcoCheck16 } from '@onefootprint/icons';
import type React from 'react';
import type { JSX } from 'react';
import Highlighter from 'react-highlight-words';
import type { CommonPropsAndClassName, GroupBase } from 'react-select';
import Flag from '../../../flag';
import type { PhoneSelectOption } from '../../phone-input.types';
export interface OptionProps<Option = unknown, IsMulti extends boolean = boolean, Group extends GroupBase<Option> = GroupBase<Option>> extends CommonPropsAndClassName<Option, IsMulti, Group> {
  innerRef: React.RefCallback<HTMLDivElement>;
  innerProps: JSX.IntrinsicElements['div'];
  data: Option;
  isFocused: boolean;
  isSelected: boolean;
}
const Option = t0 => {
  const $ = _c(23);
  const {
    innerRef,
    isFocused,
    isSelected,
    innerProps,
    data,
    selectProps
  } = t0;
  const {
    inputValue
  } = selectProps;
  const {
    label,
    value
  } = data as unknown as PhoneSelectOption;
  const t1 = innerProps.id;
  const t2 = innerProps.onClick;
  const t3 = innerProps.onMouseMove;
  const t4 = innerProps.onMouseOver;
  const t5 = innerProps.tabIndex;
  let t6;
  if ($[0] !== value) {
    t6 = <Flag className="mr-2 min-w-5" code={value} />;
    $[0] = value;
    $[1] = t6;
  } else {
    t6 = $[1];
  }
  let t7;
  if ($[2] !== inputValue) {
    t7 = inputValue.split(" ");
    $[2] = inputValue;
    $[3] = t7;
  } else {
    t7 = $[3];
  }
  let t8;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      background: "none",
      color: "var(--text-color-primary)",
      fontWeight: 600
    };
    $[4] = t8;
  } else {
    t8 = $[4];
  }
  let t9;
  if ($[5] !== label || $[6] !== t7) {
    t9 = <Highlighter searchWords={t7} textToHighlight={label} highlightStyle={t8}>{label}</Highlighter>;
    $[5] = label;
    $[6] = t7;
    $[7] = t9;
  } else {
    t9 = $[7];
  }
  let t10;
  if ($[8] !== t6 || $[9] !== t9) {
    t10 = <div className="flex items-center">{t6}{t9}</div>;
    $[8] = t6;
    $[9] = t9;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] !== isSelected) {
    t11 = isSelected && <IcoCheck16 color="primary" />;
    $[11] = isSelected;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  let t12;
  if ($[13] !== innerProps.id || $[14] !== innerProps.onClick || $[15] !== innerProps.onMouseMove || $[16] !== innerProps.onMouseOver || $[17] !== innerProps.tabIndex || $[18] !== innerRef || $[19] !== isFocused || $[20] !== t10 || $[21] !== t11) {
    t12 = <div className="fp-phone-option text-body-2 absolute top-0 left-0 w-full flex items-center justify-between py-2 px-4 cursor-pointer bg-primary text-secondary" ref={innerRef} data-highlighted={isFocused} id={t1} onClick={t2} onMouseMove={t3} onMouseOver={t4} role="option" tabIndex={t5}>{t10}{t11}</div>;
    $[13] = innerProps.id;
    $[14] = innerProps.onClick;
    $[15] = innerProps.onMouseMove;
    $[16] = innerProps.onMouseOver;
    $[17] = innerProps.tabIndex;
    $[18] = innerRef;
    $[19] = isFocused;
    $[20] = t10;
    $[21] = t11;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  return t12;
};
export default Option;